import { Card, Icon, Text } from '@amzn/storm-ui'
import styled from 'styled-components'

interface MicroPartnerCardProps {
  isRtl: boolean
}

interface MicroPartnerCardHeaderProps {
  hasBadge: boolean
}
export const MicroPartnerCard = styled(Card)<MicroPartnerCardProps>`
  direction: ${({ isRtl }) => (isRtl ? 'rtl' : 'ltr')};
  display: flex;
  flex-direction: column;
  min-width: calc(17.5ch);
`

export const MicroPartnerCardContainer = styled.div`
  display: flex;
  flex: 1;
  min-width: 17.5ch;
  flex-basis: 0;
`

export const MicroPartnerCardHeader = styled.div<MicroPartnerCardHeaderProps>`
  display: flex;
  justify-content: ${({ hasBadge }) => (hasBadge ? 'space-between' : 'flex-end')};
`

export const CloseIcon = styled(Icon)`
  color: ${({ theme }) => theme.palette.dustyGray};
  cursor: pointer;
`

export const CompanyNameText = styled(Text)`
  white-space: nowrap;
  overflow: hidden;
  display: inline-block;
  text-overflow: ellipsis;
  min-width: 15ch;
  max-width: 100%;
  margin-top: ${({ theme }) => theme.spacing.mini};
`
